import {
  PRODUCT_RECS_REQUEST,
  PRODUCT_RECS_SUCCESS,
  PRODUCT_RECS_FAIL,
  CART_RECS_REQUEST,
  CART_RECS_SUCCESS,
  CART_RECS_FAIL,
} from "../constants/upsellConstants";

export const productRecommendationsReducer = (
  state = { recommendations: [], isPatternBased: false },
  action,
) => {
  switch (action.type) {
    case PRODUCT_RECS_REQUEST:
      return { ...state, loading: true };
    case PRODUCT_RECS_SUCCESS:
      return {
        loading: false,
        recommendations: action.payload.recommendations,
        isPatternBased: action.payload.is_pattern_based,
      };
    case PRODUCT_RECS_FAIL:
      return { loading: false, recommendations: [], isPatternBased: false };
    default:
      return state;
  }
};

export const cartRecommendationsReducer = (
  state = { recommendations: [], isPatternBased: false },
  action,
) => {
  switch (action.type) {
    case CART_RECS_REQUEST:
      return { ...state, loading: true };
    case CART_RECS_SUCCESS:
      return {
        loading: false,
        recommendations: action.payload.recommendations,
        isPatternBased: action.payload.is_pattern_based,
      };
    case CART_RECS_FAIL:
      return { loading: false, recommendations: [], isPatternBased: false };
    default:
      return state;
  }
};
